import { put } from 'redux-saga/effects';

import axios from '../../api/axios';
import * as actions from '../actions/index';
import { URL_CONFIG } from '../../shared/config/index';
import { AuthSessionStorage, SiteSessionStorage, AuthLocalStorage } from '../../shared/classes/index';

export function* logoutSaga(action) {
    const authSessionStorage = new AuthSessionStorage();
    yield authSessionStorage.deleteAuthDetails();
    yield put(actions.logoutSucceed());
}

export function* authUserSaga(action) {
    yield put(actions.authStart());

    const authSessionStorage = new AuthSessionStorage();
    const siteSessionStorage = new SiteSessionStorage();
    const authLocalStorage = new AuthLocalStorage();
    const authData = {
        username: action.username,
        password: action.password,
        region: action.region.toLowerCase(),
        appname: process.env.REACT_APP_NAME
    };

    try {
        const res = yield axios.post(URL_CONFIG.loginApi, {}, { headers: authData });
        if (res && res.data && res.data.statusCode === 200) {
            const user = yield {
                username: action.username,
                region: action.region
            };
            yield authSessionStorage.setAuthDetails(user, res.data.jwtToken);
            yield siteSessionStorage.setFavorites(res.data.favoriteSites);
            yield siteSessionStorage.setSelectedSite(res.data.selectedSite);
            yield authLocalStorage.setAuthStoreDetails(action.region, action.username);
            yield put(actions.authSuccess(res.data.jwtToken, user));
        } else if(res.data.statusCode === 405) {
            throw({ message: 'You have exceeded the number of login attempts. Please create ITSC ticket for MSDO Live app.' });
        } else {
            throw({ message: 'You have entered an invalid username or password.' });
        }
    } catch (err) {
        yield put(actions.authFail(err.message));
    }
}

export function* authCheckStateSaga(action) {
    const authSessionStorage = new AuthSessionStorage();
    const token = yield authSessionStorage.authToken;
    if (!token) {
        yield put(actions.logout());
    } else {
        const user = yield authSessionStorage.authUser;
        yield put(actions.authSuccess(token, user));
    }
}